import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import { object, string, func } from "prop-types";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import keys from "lodash/keys";
import { Helmet } from "react-helmet";

import RRTable from "./components/RRTable";
import BarChartBlock from "./components/BarChartBlock";
import TabBar from "../../components/TabBar";
import SummaryTable from "./components/SummaryTable";

import fetchPageApi from "./actions/fetchPageApi";

export class Performance extends Component {
  static propTypes = {
    fetchPageApi: func.isRequired,
    match: object.isRequired,
    history: object.isRequired,
    token: string.isRequired,
    company: string.isRequired,
    performance: object,
  };
  static defaultProps = {
    performance: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      initTab: false,
    };
  }
  componentDidMount() {
    const { match, fetchPageApi, token, performance, company } = this.props;
    const { year, month } = match.params;
    if (!performance[year] || !performance[year][month]) {
      fetchPageApi(company, year, month, token);
    }
  }

  sortPerformanceData = (keys) => {
    const ret = [];
    const expect = ["rr3", "rr4", "rr5", "performance"];
    for (let key of expect) {
      if (keys.indexOf(key) >= 0) {
        ret.push(key);
      }
    }
    for (let key of keys) {
      if (expect.indexOf(key) < 0) {
        ret.push(key);
      }
    }
    return ret;
  };

  render() {
    const { sortPerformanceData } = this;
    const { performance, match } = this.props;
    const { projectId, year, month } = match.params;
    if (!performance[year] || !performance[year][month]) {
      return null;
    }
    const performanceData = performance[year][month];
    const tabs = sortPerformanceData(keys(performanceData)).map((tab) => ({
      name: tab.toUpperCase(),
      url: `${year}/${month}/performance/${tab}`,
      key: tab,
    }));
    if (!this.state.initTab) {
      this.props.history.replace(`/${projectId}/${tabs[0].url}`);
      this.setState({ initTab: true });
    }
    const perfReports = sortPerformanceData(keys(performanceData));
    console.log({ perfReports });
    const firstKey = keys(performanceData.rr3.groups[0]).filter(
      (k) => k !== "name" && k !== "fund_id"
    )[2];
    const secondKey = keys(performanceData.rr3.groups[0]).filter(
      (k) => k !== "name" && k !== "fund_id"
    )[1];
    const thirdKey = keys(performanceData.rr3.groups[0]).filter(
      (k) => k !== "name" && k !== "fund_id"
    )[0];
    return (
      <div>
        <Helmet>
          <title>月報-投資組合現況與績效</title>
        </Helmet>
        <TabBar tabs={tabs} />
        <Switch>
          {perfReports.map((report) => (
            <Route
              key={report}
              path={`/${projectId}/${year}/${month}/performance/${report}`}
              render={() => (
                <div>
                  {report === "summary" ? (
                    <Grid container>
                      <SummaryTable
                        data={performanceData[report]}
                        footnote={performanceData[report].footnote}
                        keys={perfReports}
                      />
                    </Grid>
                  ) : (
                    <Grid container>
                      <BarChartBlock
                        data={performanceData[report].groups.reduce(
                          (pre, cur) => {
                            pre[0][cur.name] = cur[firstKey];
                            pre[1][cur.name] = cur[secondKey];
                            pre[2][cur.name] = cur[thirdKey];
                            return pre;
                          },
                          [
                            {
                              name:
                                firstKey.substr(0, 1).toUpperCase() +
                                firstKey.substr(1).toLowerCase(),
                            },
                            {
                              name:
                                secondKey.substr(0, 1).toUpperCase() +
                                secondKey.substr(1).toLowerCase(),
                            },
                            {
                              name:
                                thirdKey.substr(0, 1).toUpperCase() +
                                thirdKey.substr(1).toLowerCase(),
                            },
                          ]
                        )}
                        stackIds={keys(performanceData[report].groups).reduce(
                          (pre, cur) => {
                            pre[performanceData[report].groups[cur].name] = 1;
                            return pre;
                          },
                          {}
                        )}
                      />
                      <RRTable
                        data={performanceData[report].funds}
                        footnote={performanceData[report].footnote}
                      />
                    </Grid>
                  )}
                </div>
              )}
            />
          ))}
        </Switch>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    performance: state.performance,
    token: state.appState.userToken,
    company: state.appState.company,
  };
}

const dispatchObj = {
  fetchPageApi,
};

export default connect(mapStateToProps, dispatchObj)(Performance);



// WEBPACK FOOTER //
// ./src/scenes/Performance/index.js